
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#231f20"},attrs:{"d":"M46.2,11.56c2.96,0,5.74,1.11,7.82,3.14,4.28,4.43,4.24,11.2-.11,15.79l-21.91,23.21L10.08,30.47c-4.36-4.59-4.38-11.39-.06-15.82,2.44-2.5,5.58-3.02,7.78-3.02s5.31.52,7.74,2.98l2.08,2.22,4.38,4.67,4.38-4.67,2.04-2.17c2.08-2,4.84-3.1,7.79-3.1h0ZM46.2,5.56c-4.37,0-8.74,1.63-12.07,4.9l-2.13,2.27-2.13-2.27c-3.33-3.41-7.71-4.83-12.07-4.83s-8.74,1.42-12.07,4.83c-6.66,6.82-6.47,17.33,0,24.14l26.28,27.84,26.28-27.84c6.47-6.82,6.66-17.33,0-24.14-3.33-3.27-7.7-4.9-12.07-4.9h0Z"}})])
          )
        }
      }
    